import React from "react";
import Reveal from "./Reveal";
import { SECTORS, IMAGES } from "../mock";
import { scrollTo } from "./Navbar";

const Sectors = () => {
  return (
    <section id="sectores" className="bg-1 dots py-28" data-testid="sectors-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal className="text-center">
          <p className="label">A quién nos dirigimos</p>
          <h2 className="h-section mt-4">Sectores</h2>
          <p className="text-muted mt-4 max-w-xl mx-auto">Industrias y centros de datos con alto consumo energético y demanda continua.</p>
        </Reveal>
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {SECTORS.map((s, i) => (
            <Reveal key={s.title} delay={i * 90}>
              <button onClick={() => scrollTo("contacto")} className="group relative block w-full h-[380px] overflow-hidden text-left" data-testid={`sector-card-${i}`}>
                <img src={IMAGES[s.image]} alt={s.title} className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700" />
                <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(25,25,25,0.92) 10%, rgba(25,25,25,0) 60%)" }} />
                <span className="absolute top-5 left-5 bg-white text-black text-[10px] font-semibold tracking-wider uppercase rounded-full px-3.5 py-2">
                  {s.detail}
                </span>
                <p className="absolute bottom-6 left-5 right-5 text-white text-xl font-medium leading-tight">{s.title}</p>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Sectors;
